import React from 'react'

const TeleportPrimaryIcon = props => (
  <svg viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="58" height="58" rx="13.8095" fill="#FF9494" />
    <rect
      x="0.0107422"
      y="0.00549316"
      width="57.9892"
      height="57.9892"
      rx="13.8095"
      fill="url(#paint0_linear)"
    />
    <ellipse cx="19.0857" cy="28.9845" rx="10.7999" ry="10.9769" fill="white" />
    <circle cx="38.7373" cy="28.9846" r="10.9769" fill="white" />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="13.5619"
        y1="-23.3007"
        x2="54.3308"
        y2="42.2417"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#326EB2" />
        <stop offset="1" stopColor="#FF9494" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export default TeleportPrimaryIcon
